import { backendServices } from "./backend.service";
import { web3Services } from "./web3.service";

type Services = typeof backendServices & typeof web3Services;

export const services: Services = { ...backendServices, ...web3Services };
